import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';

import { type GetSocialBindsRequesSuccessAction, type UserSocialBindsState, UserSocialBindType } from './userSocialBinds.types';

const initialState: UserSocialBindsState = {
    accounts: [],
    isLoading: false,
    isLoaded: false,
    hasError: false,
};

export const getUserSocialBindsRequest = createAction('socialBinds/getUserSocialBindsRequest');
export const getUserSocialBindsSuccess = createAction<GetSocialBindsRequesSuccessAction>('socialBinds/getUserSocialBindsSuccess');
export const getUserSocialBindsFailure = createAction('socialBinds/getUserSocialBindsFailure');

const MapTypeToRegex: Record<UserSocialBindType, RegExp> = {
    [UserSocialBindType.vkid]: /(.*)@vk/,
    [UserSocialBindType.unknown]: /(.*)/,
};

const handleUserSocialBindsSuccessAction = (
    state: UserSocialBindsState,
    { payload: { socialBinds } }: PayloadAction<GetSocialBindsRequesSuccessAction>
): UserSocialBindsState => {
    const accounts = socialBinds?.accounts;

    if (!Array.isArray(accounts)) {
        return {
            accounts: [],
            isLoading: false,
            isLoaded: true,
            hasError: false,
        };
    }

    const mappedAccounts = accounts
        .filter(({ login }) => login)
        .map(({ login, first_name, last_name }) => {
            for (const key in MapTypeToRegex) {
                const regexp = MapTypeToRegex[key];
                if (regexp.test(login)) {
                    return {
                        loginParsed: login?.match(regexp)?.[1] || '',
                        login: login || '',
                        firstName: first_name || '',
                        lastName: last_name || '',
                        type: key as UserSocialBindType,
                    };
                }
            }
            return {
                type: UserSocialBindType.unknown,
                login: login || '',
                firstName: first_name || '',
                lastName: last_name || '',
                loginParsed: login || '',
            };
        });

    return {
        ...state,
        accounts: mappedAccounts,
        isLoading: false,
        isLoaded: true,
        hasError: false,
    };
};

export const userSocialBindsReducer = createReducer(initialState, {
    [getUserSocialBindsSuccess.type]: handleUserSocialBindsSuccessAction,
    [getUserSocialBindsRequest.type]: (state: UserSocialBindsState) => {
        state.isLoading = true;
    },
    [getUserSocialBindsFailure.type]: (state: UserSocialBindsState) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.hasError = true;
    },
});
